import { client } from '../utils/client'
import type { IperiaStatusPayload } from '../types/iperiaStatus'

function iperiaApiBase(globalId: string): string {
  return `/registration/${globalId}/iperia`
}

export async function fetchIperiaStatus(globalId: string): Promise<IperiaStatusPayload> {
  const response = await client.get<IperiaStatusPayload>(`${iperiaApiBase(globalId)}/status/`)
  return response.data
}

export async function updateLearnerSummary(
  globalId: string,
  learnerSummary: Partial<IperiaStatusPayload['learner_summary']>,
): Promise<IperiaStatusPayload> {
  const response = await client.patch<IperiaStatusPayload>(
    `${iperiaApiBase(globalId)}/learner_summary/`,
    learnerSummary,
  )
  return response.data
}

export async function confirmLearnerSummary(
  globalId: string,
  learnerSummary?: IperiaStatusPayload['learner_summary'],
): Promise<IperiaStatusPayload> {
  const response = await client.post<IperiaStatusPayload>(
    `${iperiaApiBase(globalId)}/confirm_learner_summary/`,
    learnerSummary ? { learner_summary: learnerSummary } : undefined,
  )
  return response.data
}

const UPLOAD_TIMEOUT_MS = 60_000

export async function uploadDocument(
  globalId: string,
  file: File,
  documentType: string,
): Promise<IperiaStatusPayload> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('document_type', documentType)
  const response = await client.post<IperiaStatusPayload>(
    `${iperiaApiBase(globalId)}/upload_document/`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      // Une photo de 10 Mo depuis un mobile dépasse vite les 10 s du client par défaut.
      timeout: UPLOAD_TIMEOUT_MS,
    },
  )
  return response.data
}

export async function submitDocuments(globalId: string): Promise<IperiaStatusPayload> {
  const response = await client.post<IperiaStatusPayload>(
    `${iperiaApiBase(globalId)}/submit_documents/`,
  )
  return response.data
}

export async function updateParentEmployeur(
  globalId: string,
  data: Record<string, any>,
): Promise<IperiaStatusPayload> {
  const response = await client.patch<IperiaStatusPayload>(
    `${iperiaApiBase(globalId)}/parent_employeur/`,
    data,
  )
  return response.data
}

export async function submitNir(
  globalId: string,
  nir: string,
  authorizationDataUse: boolean,
): Promise<IperiaStatusPayload> {
  const response = await client.patch<IperiaStatusPayload>(`${iperiaApiBase(globalId)}/submit_nir/`, {
    social_security_number: nir,
    authorization_data_use: authorizationDataUse,
  })
  return response.data
}
